/**
 * Утилиты для обработки элементов настройки представления содержимого актива
 */

 /**
  * Возвращает идентификатор для первого представления графа
  * @param views 
  */
 export const getGraphViewId = views => {
   if(views && Array.isArray(views)){
    for (let i = 0; i < views.length; i++) {
      const element = views[i];
      if (element.type == "graph") return element.id;
    }
   }
   return null;
 }

/**
 * Формирование структуры для настройки графа по настройке представления 
 * @param {*} view 
 * Примеры
 * 
 * const rdfs_sparql = {
 *  endpoint: "http://sparql.semanticpro.org/sparql", 
 *  graph: "http://www.w3.org/2000/01/rdf-schema#", 
 *  sparql: "select ?s ?p ?o where { ?s ?p ?o }",
 *  settings:{
 *    //Узлы, которых надо создавать (указываются типы узлов). Т.е. s, которые имеют значение o для предиката http://www.w3.org/1999/02/22-rdf-syntax-ns#type
 *    createNodes:["http://www.w3.org/2000/01/rdf-schema#Datatype", "http://www.w3.org/2000/01/rdf-schema#Class", "http://www.w3.org/1999/02/22-rdf-syntax-ns#List", "http://www.w3.org/1999/02/22-rdf-syntax-ns#Property"],
 *    //Типы, которые надо создавать. Т.е. значения o для предиката http://www.w3.org/1999/02/22-rdf-syntax-ns#type
 *    createTypes:["http://www.w3.org/2000/01/rdf-schema#Class", "http://www.w3.org/1999/02/22-rdf-syntax-ns#Property"],
 *    //Флаг, что тип определяет родительский класс. Т.е. устанавливается связь rdfs:SubClassOf
 *    typeAsSuperClass: true
 *  }
 */
export const makeSettings = view => {
  //console.log("export const makeSettings = view =>", view, JSON.stringify(view));
  const settings = {endpoint: view.endpoint, graph: view.graph, sparql: view.sparql, type: view.show_type};
  if (view.extra_options){
    if (typeof settings.settings === "undefined") settings.settings = {};
    if (typeof view.extra_options === 'string' || view.extra_options instanceof String){
      //console.log(view.extra_options);
      try {
        settings.settings.extra_options = JSON.parse(view.extra_options);
      } catch(e) {
        console.error("Ошибка парсинга JSON с параметрами настройки графа.", e);
      }
    } else {
      settings.settings.extra_options = view.extra_options;
    }
  }
//Заполним createTypes
   if (Array.isArray(view.createTypes) && view.createTypes.length>0){
      const createTypes = view.createTypes.filter(item => item.uri && item.uri.startsWith("http")).map(item => item.uri);
      if (createTypes.length>0){
        if (typeof settings.settings === "undefined") settings.settings = {};
          settings.settings.createTypes = createTypes;
      }
  }

//Заполним linksFilter
   if (Array.isArray(view.linksFilter) && view.linksFilter.length>0){
      const linksFilter = view.linksFilter.filter(item => item.uri && item.uri.startsWith("http")).map(item => item.uri);
      if (linksFilter.length>0){
        if (typeof settings.settings === "undefined") settings.settings = {};
          settings.settings.linksFilter = linksFilter;
      }
  }

//Заполним typesFilter
  if (Array.isArray(view.typesFilter) && view.typesFilter.length>0){
    const createNodes = view.typesFilter.filter(item => item.uri && item.uri.startsWith("http")).map(item => item.uri);
    if (createNodes.length>0){
      if (typeof settings.settings === "undefined") settings.settings = {};
        settings.settings.createNodes = createNodes;
    }
  }

//Заполним labelsFilter
  if (Array.isArray(view.labelsFilter) && view.labelsFilter.length>0){
    const labelNodes = view.labelsFilter.filter(item => item.uri && item.uri.startsWith("http")).map(item => item.uri);
    if (labelNodes.length>0){
      if (typeof settings.settings === "undefined") settings.settings = {};
        settings.settings.labelNodes = labelNodes;
    }
  }

  if (view.typeAsSuperClass){
    if (typeof settings.settings === "undefined") settings.settings = {};
    settings.settings.typeAsSuperClass = view.typeAsSuperClass;
  }

  //legend
  if (view.legend){
    settings.legend = view.legend;
  }

//  console.log("export const makeSettings = view =>", view, settings);
  return settings;
}